exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".quick-filter[data-v-611c38c4] {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-align: center;\n      -ms-flex-align: center;\n          align-items: center;\n  margin-bottom: 16px;\n  -ms-flex-wrap: wrap;\n      flex-wrap: wrap;\n  gap: 8px;\n}\n.quick-filter .filter-label[data-v-611c38c4] {\n  color: #666;\n  font-size: 14px;\n}\n.quick-filter .time-filter[data-v-611c38c4] {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-align: center;\n      -ms-flex-align: center;\n          align-items: center;\n}\n", ""]);

// exports
